import {version, build} from '../package.json';
export const VERSION = version + '.' + build

// MEMO: browser https://github.com/lancedikson/bowser/blob/master/src/constants.js
/*
export const VALID_BROWSER_BASE = {
  windows: {
    "internet explorer": ">10",
  },
  macos: {
    safari: ">11"
  },
  mobile: {
    safari: '>=9',
    // 'android browser': '>3.10'
  },
  tablet: {
    safari: '>=9',
    // 'android browser': '>3.10'
  },
  // or in general
  // chrome: "~20.1.1432",
  chrome: ">=40",
  firefox: ">=35",
}
*/
export const VALID_BROWSER_MOBILE = {
  mobile: {
    safari: '>=9',
  },
  tablet: {
    safari: '>=9',
  },
  chrome: ">=40",
}
export const VALID_BROWSER_WIN_7 = {
  windows: {
    "internet explorer": ">8",
  }
}
export const VALID_MOBILE = {
  chrome: ">=40",
  safari: '>=9',
}
export const STATE = {
  PROGRESS: 0,
  OK: 1,
  WARN: 2,
  ERROR: 3,
}